import React, { useEffect, useState, useContext } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Card, CardHeader, Icon } from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import Pagination from "@mui/material/Pagination";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useNavigate } from "react-router-dom";
import AppointmentsApi from "../../../../Classes/API/Appointments/AppointmentsApi";
import { LanguageContext } from "App";
import SearchStringOrIntReq from "../../../../Classes/Models/Requests/SearchStringOrIntReq";
import Swal from "sweetalert2";
const PatientSuggestions = () => {
  const [SearchReq, setSearchReq] = useState(new SearchStringOrIntReq());
  const [ResponseData, setResposneData] = useState({});
  const [IsLoaded, setIsLoaded] = useState(false);
  const [TableDataRows, setTableDataRows] = useState([]);
  const { translations } = useContext(LanguageContext);
  const [Page, setPage] = useState(1);
  const [TotalPages, setTotalPages] = useState(0);
  const TableColumns = [
    { Header: "Patient Name", accessor: "Name", align: "left" },
    { Header: "Sessions", accessor: "Sessions", align: "left" },
  ];

  const ToggleHideSuggestion = async (Id) => {
    let confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, hide it!",
    });
    if (!confirmation.isConfirmed) {
      return;
    }

    Swal.fire({
      title: "Please wait",
      text: "Hiding suggestion",
      allowOutsideClick: false,
      allowEscapeKey: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });
    let req = new SearchStringOrIntReq();
    req.SearchInt = Id;
    let res = await AppointmentsApi.ToggleHideSuggestion(req);
    if (res.status == "Success") {
      Swal.fire("Success", "Suggestion hidden", "success");
      setIsLoaded(false);
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  const MakeTableRow = (Patient) => {
    const bgColors = ["#0d47a1", "#1565c0", "#1976d2", "#1e88e5", "#2196f3"];
    return {
      Name: (
        <MDBox display="flex" flexDirection="row" alignItems="center">
          <button
            className="btn btn-sm btn-dark mr-3"
            onClick={() => ToggleHideSuggestion(Patient.id)}
          >
            <Icon>visibility_off</Icon>
          </button>
          <span>{Patient.getUser.name}</span>
        </MDBox>
      ),

      Sessions: (
        <MDTypography variant="button" color="text" fontWeight="medium">
          {Patient.getAccountingSessions.length} Total Sessions: &nbsp; &nbsp;
          {getUnqiqueSessionsAndCount(Patient.getAccountingSessions)
            .sort((a, b) => a.Count - b.Count)
            .map((session, index) => {
              return (
                <span
                  style={{
                    backgroundColor: bgColors[index > bgColors.length - 1 ? 3 : index],
                    padding: "5px",
                    borderRadius: "5px",
                    color: "white",
                    marginRight: "5px",
                    fontSize: "12px",
                    border: "1px solid black",
                  }}
                >
                  {session.Name} : {session.Count}
                </span>
              );
            })}
        </MDTypography>
      ),
    };
  };

  // get distinct session.name and their count in the list of sessions as array of objects [{sessionName, count}]
  const getUnqiqueSessionsAndCount = (sessions) => {
    let uniqueSessions = [];
    sessions?.forEach((session) => {
      if (!uniqueSessions.includes(session.sessionName)) {
        uniqueSessions.push(session.sessionName);
      }
    });

    let finalArray = [];
    uniqueSessions?.forEach((sessionName) => {
      let count = sessions.filter((x) => x.sessionName == sessionName).length;
      finalArray.push({ Name: sessionName, Count: count });
    });

    return finalArray;
  };

  const RefreshTable = (resList) => {
    var rows = [];
    resList?.forEach((Entry) => {
      rows.push(MakeTableRow(Entry));
    });
    setTableDataRows(rows);
  };

  useEffect(async () => {
    if (Object.keys(ResponseData).length > 1) {
      RefreshTable(ResponseData.list);
    }
  }, [ResponseData]);

  useEffect(() => {
    //Check if data is loaded
    if (Object.keys(ResponseData).length > 0) {
      setIsLoaded(true);
    } else {
      setIsLoaded(false);
    }
  }, [ResponseData]);

  const onSearch = async () => {
    SearchReq.pagingParams.pageNumber = Page;
    SearchReq.pagingParams.pageSize = 10;
    let res = await AppointmentsApi.GetPatientSuggestions(SearchReq);
    if (res.status == "Success") {
      setResposneData(res.data);
      setTotalPages(res.data.totalPages);
    }
  };

  useEffect(() => {
    onSearch();
  }, [SearchReq]);

  useEffect(() => {
    onSearch();
  }, [Page]);

  useEffect(() => {
    if (!IsLoaded) {
      onSearch();
      setIsLoaded(true);
    }
  }, [IsLoaded]);

  if (!IsLoaded && Object.keys(ResponseData).length < 1) {
    return (
      <div>
        <MDBox>
          <MDTypography component="a" variant="button" color="text" fontWeight="medium">
            Loading Log Data...
          </MDTypography>
        </MDBox>
      </div>
    );
  }

  return (
    <div>
      <Card sx={{ marginTop: "2em", width: "100%" }}>
        <CardHeader title={translations.PatientSuggestions} />
        <MDBox pt={3}>
          <DataTable
            table={{ columns: TableColumns, rows: TableDataRows }}
            isSorted={false}
            entriesPerPage={false}
            showTotalEntries={false}
            noEndBorder
          />
        </MDBox>

        <div className="mx-3 my-4 d-flex justify-content-center">
          <Pagination count={TotalPages} onChange={(e, num) => setPage(num)} color="primary" />
        </div>
      </Card>
    </div>
  );
};

export default PatientSuggestions;
